// extracted by mini-css-extract-plugin
export default {"category_name_tag":"styles_category_name_tag__Bxpwf","category_name_label":"styles_category_name_label__Dkmuy"};